import React from "react"
import classNames from "classnames"

import { parseMaxCapacity, getOccupancyPct } from "../utils/occupancy"
import { getEventColor } from "../utils/gridUtils"

const GradeEventCard = ({
  schedule,
  onClick,
  isSelected,
  selectionMode = false,
  selectionType = 'regular',
  isEnrolled = false // Nova prop para indicar matrícula existente
}) => {
  const startTime = String(schedule?.startTime || "")
  const endTime = String(schedule?.endTime || "")

  const maxCapacityRaw = schedule?.maxCapacity
  const maxCapacity = parseMaxCapacity(maxCapacityRaw)
  const enrolledCount = Math.max(0, Number(schedule?.enrolledCount || 0))
  const occupancyPct = getOccupancyPct(enrolledCount, maxCapacityRaw)

  const activityName = schedule?.activityName || "Atividade"
  const rawName = schedule?.employeeName || ""
  const teacherDisplayName = rawName ? `Prof. ${rawName.split(" ")[0]}` : ""
  const areaName = schedule?.areaName || ""

  const color = getEventColor(schedule)

  const isCanceled = schedule?.status === 'CANCELED'
  const isSubstitution = schedule?.isSubstitution === true

  const attendedCount = Array.isArray(schedule?.attendances) ? schedule.attendances.filter(a => a.status === 'ATTENDED').length : 0;
  const presentCount = schedule?.presentCount ?? attendedCount;

  const occupancyClass = isCanceled 
      ? "opacity-50"
      : occupancyPct === null
      ? ""
      : occupancyPct >= 1
        ? "grade-event--full"
        : occupancyPct >= 0.7
          ? "grade-event--busy"
          : "grade-event--ok"

  return (
    <div
      className={classNames("grade-event", occupancyClass, {
        "grade-event--selected": isSelected && !selectionMode,
        "grade-cell--selected": isSelected && selectionMode && selectionType === 'regular',
        "grade-cell--selected-trial": isSelected && selectionMode && selectionType === 'trial',
        "grade-cell--enrolled": isEnrolled && selectionMode, // Nova classe para matrícula existente
        "selectable": selectionMode
      })}
      style={color && !isCanceled ? {
        backgroundColor: `color-mix(in srgb, ${color} 28%, white)`,
        borderLeft: `5px solid ${color}`,
        borderColor: `color-mix(in srgb, ${color} 60%, white)`
      } : isCanceled ? {
        backgroundColor: "#f8f9fa",
        borderLeft: "5px solid #ccc",
        borderColor: "#d1d5db"
      } : {}}
      onClick={(e) => {
        e.stopPropagation();

        if (onClick) onClick(e);
      }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="grade-event__badge-wrapper">
        {isCanceled ? (
          <span className="badge bg-danger shadow-sm text-white px-2 py-1 font-size-10 text-uppercase fw-bold rounded-pill grade-event__canceled-badge">Canc.</span>
        ) : (
          <span className="grade-event__capacity-badge">
            {enrolledCount}/{maxCapacity === "-" ? "—" : maxCapacity}
            {!!schedule?.experimentalCount && (
              <span className="ms-1 text-warning fw-bold">({schedule.experimentalCount})</span>
            )}
          </span>
        )}
      </div>

      <div className="d-flex flex-column h-100 position-relative z-1">
        <div
          className={classNames("grade-event__title fw-bold lh-sm mb-1", {
            "text-decoration-line-through text-muted": isCanceled
          })}
        >
          {activityName}
        </div>

        <div className="d-flex flex-column gap-1 mt-auto">
          <div className="grade-event__meta d-flex align-items-center">
            <i className="mdi mdi-clock-outline me-1"></i>
            {startTime}–{endTime}
          </div>

          {teacherDisplayName && (
            <div className="grade-event__meta d-flex align-items-center">
              <i className="mdi mdi-account-star-outline me-1"></i>
              <span className="grade-event__meta-text">{teacherDisplayName}</span>
              {isSubstitution && !isCanceled && (
                <span className="ms-auto badge bg-warning text-dark grade-event__sub-badge">Sub</span>
              )}
            </div>
          )}

          {areaName && (
            <div className="grade-event__meta d-flex align-items-center">
              <i className="mdi mdi-map-marker-outline me-1"></i>
              <span className="grade-event__meta-text">{areaName}</span>
            </div>
          )}

          {!isCanceled && Number(schedule?.waitlistCount || 0) > 0 && (
            <span className="badge bg-warning bg-opacity-25 text-warning d-inline-flex align-items-center mt-1 align-self-start grade-event__waitlist-badge">
              <i className="mdi mdi-account-clock-outline me-1"></i>
              {schedule.waitlistCount} espera
            </span>
          )}
        </div>
      </div>

      {schedule?.attendanceCompleted && (
        <div className="grade-event__attendance-count" title={`Presenças: ${presentCount}`}>
          <span className="fw-bold me-1">{presentCount}</span>
          <i className="mdi mdi-thumb-up"></i>
        </div>
      )}
    </div>
  )
}

export default GradeEventCard
